import { get, post } from "./api";
import { Booking } from "../models/models";
import { useBooking } from "../components/BookingContextProvider";
import { servicePath, apiDateFormat, dashboardUrl, sessionExpiredUrl } from "../components/Settings";
import dayjs from "dayjs";

export let timeoutHandle: number;

export async function abandon(url: string, booking: Booking, setLoading: (loading: boolean) => void, ignoreWindowLocation: boolean = false) {
	setLoading(true);

	await post(url, booking)
		.then(response => {
			window.sessionStorage.setItem("booking", JSON.stringify({}));
			if (!ignoreWindowLocation) {
				if (window.location.hash !== "bookingDetails") {
					window.location.hash = "bookingDetails";
				}

				window.location.reload();
			}
		});
}

export function redirectBookingDetails() {
	const { loading, setLoading } = useBooking();

	setLoading(true);
	window.sessionStorage.setItem("booking", JSON.stringify({}));
	window.location.hash = "bookingDetails";
}

export async function checkClientErrorResponse(response: any, booking: Booking) {
	if (response.errors) {

		const error = response.errors[0].message;
		console.log(`checkClientErrorResponse: error ${error}`);

		if (response.errors[0].redirectToHash) {
			if (response.errors[0].redirectToHash === "Maintenance") {
				await post(servicePath + "abandon", booking);
			}

			window.location.hash = response.errors[0].redirectToHash;
		} else if (response.errors[0].redirectToSessionExpired) {
			await redirectToSessionExpired(booking);
		} else {
			window.sessionStorage.setItem("booking", JSON.stringify({
				...booking,
				...{ clientErrorResponseMessage: error }
			}));

			booking.clientErrorResponseMessage = error;
		}

		return false;
	}

	console.log(`checkClientErrorResponse: No error. booking ${booking}`);
	window.sessionStorage.setItem("booking", JSON.stringify({
			...booking,
			...{ clientErrorResponseMessage: "" }
		}));

	booking.clientErrorResponseMessage = "";

	return true;
}

export function urlRedirect(jwt: any, state: any, setLoading: (loading: boolean) => void) {
	if (state) {
		switch (state.action) {
			case "new":
				window.sessionStorage.setItem("booking", JSON.stringify({}));
				window.location.replace(window.location.origin + "/#/bookingDetails");
				break;

			case "change":
				if (state.bookingID > 0) {
					uploadBooking(state.bookingID);
				} else {
					window.location.replace(window.location.origin);
				}

				break;

			case "validateCreditCard":
				window.location.replace(window.location.origin + "/#/validateCreditCard");
				break;

			default:
				window.location.replace(window.location.origin);
				break;
		}
	} else if (jwt) {
		window.location.replace(window.location.origin + "/#/bookingDetails");
	} else {
		setLoading(false);
	}
}

const uploadBooking = (bookingID: number) => {
	let booking: Booking = {} as Booking;

	booking.originalBookingID = bookingID;

	post(servicePath + "upload", booking)
		.then(response => {
			console.log(response)
			checkClientErrorResponse(response, booking)
				.then(checkResponse => {
					console.log(`Upload booking - Check response: ${checkResponse}`);
					if (checkResponse) {
						response.searchDepartDate = dayjs(response.searchDepartDate).format(apiDateFormat);
						window.sessionStorage.setItem("booking", JSON.stringify(response));
						window.location.replace(window.location.origin + "/#/bookingDetails");
					} else {
						window.sessionStorage.setItem("booking", JSON.stringify({
							...booking,
							...{ clientErrorResponseMessage: "" }
						}));

						window.location.replace(window.location.origin + "?landingError=" + response.errors[0].message);
					}
				});
		});
};

export function logoutUser(auth: any, setLoading: (loading: boolean) => void) {
	if (auth.isLoggedIn) {
		auth.logout();
	} else {
		setLoading(false);
	}
}

export async function redirectToDashboard(auth: any, booking: Booking, setLoading: (loading: boolean) => void, redirectTo: string = dashboardUrl) {
	let crmDashboadBaseUrl = "";

	await get(servicePath + "settings").then(response => {
		if (!response.errors) {
			crmDashboadBaseUrl = response.crmDashboadBaseUrl;
		}
	});

	await abandon(servicePath + "abandon", booking, setLoading, true);

	logoutUser(auth, setLoading);
	window.location.href = crmDashboadBaseUrl + redirectTo;
}

async function redirectToSessionExpired(booking: Booking) {
	let crmDashboadBaseUrl = "";

	await get(servicePath + "settings").then(response => {
		if (!response.errors) {
			crmDashboadBaseUrl = response.crmDashboadBaseUrl;
		}
	});

	await post(servicePath + "abandon", booking).then(response => {
		window.sessionStorage.setItem("booking", JSON.stringify({}));
	});

	window.location.href = crmDashboadBaseUrl + sessionExpiredUrl;
}
